import ImportResources from "./ImportResources";
import Buildings from "./Buildings";
import Flats from "./Flats";
import Plans from "./Plans";

export default {
    "apartments.resource-bindings": ImportResources,
    "apartments.buildings": Buildings,
    "apartments.flats": Flats,
    "apartments.plans": Plans,
};
